let g = (function() { return this })() || new Function("return this")();

let hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).includes("regeneratorRuntime");

let oldRuntime = hadRuntime && g.regeneratorRuntime;

g.regeneratorRuntime = undefined;

import "regenerator-runtime"

if (hadRuntime) {
  g.regeneratorRuntime = oldRuntime;
} else {
  try {
    delete g.regeneratorRuntime;
  } catch {
    g.regeneratorRuntime = undefined;
  }
}
